module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'only-collect-in-shop': !_vm.SITE_CONFIG.rental.delivery
    }
  }, [_c('div', {
    class: {
      banner: true, quick: _vm.quick
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.page.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('SkiRentalDiscount'), _vm._v(" "), _c('div', {
    staticClass: "offer-wrapper"
  }, [_c('div', {
    staticClass: "offer-box without-delivery min-tablet",
    on: {
      "click": function($event) {
        return _vm.openWithoutDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "image blue"
  }, [_c('icon', {
    attrs: {
      "name": "hamta-sjalv",
      "scale": 5
    }
  }), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-and-pickup-with-br'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['without-delivery-content-desktop'])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-and-pickup')))]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()])])]), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('div', {
    staticClass: "offer-box with-delivery min-tablet",
    on: {
      "click": function($event) {
        return _vm.openWithDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "image red"
  }, [_c('icon', {
    attrs: {
      "name": "utkorning",
      "scale": 6
    }
  }), _vm._v(" "), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-with-delivery-to-accomodation'))
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['with-delivery-content-desktop'])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items-list max-mobile",
    on: {
      "click": function($event) {
        return _vm.openWithoutDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('div', {
    staticClass: "item-image blue"
  }, [_c('icon', {
    attrs: {
      "name": "hamta-sjalv",
      "scale": 3.8
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_c('div', {}, [(_vm.SITE_CONFIG.rental.delivery) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-and-pickup-with-br'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('h2', [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['without-delivery-content-mobile'])
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [(_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-and-pickup')))]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.rental.delivery) ? _c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
    thing: _vm.$t('general.equipment')
  })))]) : _vm._e()])])]), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery) ? _c('div', {
    staticClass: "items-list max-mobile",
    on: {
      "click": function($event) {
        return _vm.openWithDelivery()
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('div', {
    staticClass: "item-image"
  }, [_c('icon', {
    attrs: {
      "name": "utkorning",
      "scale": 4
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-body"
  }, [_c('div', {}, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('skirental.book-with-delivery-to-accomodation'))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.TEXTS['with-delivery-content-mobile'])
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper red-button"
  }, [_c('button', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('skirental.book-with-delivery')))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9927ce20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalPage.vue
// module id = 1023
// module chunks = 0